module.exports = __webpack_public_path__ + "static/media/ZSCE_MP_TROCA.3699c982.pdf";